export default __webpack_public_path__ + "43272cda3cbd41f131b9b1496c3dbf0b.svg";